import { calculateValue } from 'checkout/selectors/payment/generic'

interface TicketViewOptions {
  isBookDates?: boolean
  orderItemId?: string
  /**
   * Whether or not this item has a loyalty discount or not, making it free
   */
  hasLoyaltyDiscount?: boolean
  isLuxPlusDiscountedExperiencesEnabled?: boolean
  ticketValidation?: App.ExperienceCheckoutItemValidationState['string'],
}

/**
 * Creates a ticket view for a single ticket being purchased
 * This view takes itself being a full item view (and having a backing item)
 * so it can be used in further calculations at the ticket level
 * TODO: Update experiences to store cart items per ticket instead of per experience
 */
function mapExperienceCartItemToTicketItemView(
  cartTicketItem: App.Checkout.ExperienceItemTicket,
  ticket: App.ExperienceItemTicket,
  transactionKey: string,
  itemId: string,
  experience: App.ExperienceOffer,
  options: TicketViewOptions = {},
): App.Checkout.ExperienceItemTicketItemView {
  const { hasLoyaltyDiscount, isBookDates, orderItemId, isLuxPlusDiscountedExperiencesEnabled, ticketValidation } = options
  const hasPrice = !isBookDates && !hasLoyaltyDiscount

  const price = hasPrice ? ticket.price : 0
  const memberPrice = hasPrice && isLuxPlusDiscountedExperiencesEnabled ? ticket.memberPrice : 0
  const value = isBookDates ? 0 : calculateValue(price, ticket.discounts.base.percentage ?? 0)
  const memberValue = isBookDates || !isLuxPlusDiscountedExperiencesEnabled ? 0 : value

  const isTicketValid = !ticketValidation || ticketValidation.fetching || ticketValidation.isValid

  return {
    title: `${ticket.name}: ${experience.name}`,
    ticket,
    loyalty: {
      productType: 'experience',
    },
    item: {
      itemId,
      itemType: 'experienceTicket',
      transactionKey,
    },
    totals: {
      price,
      memberPrice,
      value,
      memberValue,
      surcharge: 0,
      extraGuestSurcharge: 0,
      taxesAndFees: ticket.taxesAndFees ?? 0,
      mobileAppDiscount: {
        amount: hasPrice ? ticket.discounts.app.amount : 0,
        percentage: (ticket.discounts.app.amount > 0 && hasPrice) ? ticket.discounts.app.percentage : 0,
      },
    },
    unavailable: !ticket || !isTicketValid,
    date: ticket.date,
    time: ticket.time,
    orderItemId,
  }
}

export default mapExperienceCartItemToTicketItemView
